export const FEATURE_NAME = '@zerops/zerops/feature/recovery-code-issued-dialog';